<template>
    <dialog-modal
        v-if="shouldRender && hasAnyPermission('asset.update_usage_category')"
        :is-processing="form.processing"
        :primary-button-label="trans('general.action.confirm')"
        :show="show"
        :submit-disabled="!canSubmit"
        @close="closeModal"
        @submit="handleSubmit"
    >
        <template #title>
            <div>
                {{ trans('assets.modal.usage_category_change.title') }}
            </div>
        </template>

        <div v-html="trans('assets.modal.usage_category_change.description')"></div>

        <form @submit.prevent="handleSubmit">
            <row class="mt-3">
                <column>
                    <jet-checkbox
                        v-model="form.tested_and_calibrated"
                        :invalid-feedback="form.errors.tested_and_calibrated"
                        :label="trans('assets.modal.operability_change.attestation.label')"
                    />
                </column>
            </row>
        </form>
    </dialog-modal>
</template>
<script setup>
import DialogModal from '@/Jetstream/DialogModal.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import { eventBus, events } from '@/eventBus';

import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { useForm } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n.js';

defineOptions({
    name: 'ConfirmAssetUsageCategoryChangeModal',
});

const emit = defineEmits(['cancel']);

const shouldRender = ref(false);
const show = ref(false);
const assetId = ref(null);

const form = useForm({
    usageCategory: 'active',
    tested_and_calibrated: false,
});

const canSubmit = computed(() => form.tested_and_calibrated === true);

function closeModal() {
    show.value = false;
    setTimeout(() => {
        shouldRender.value = false;
    }, 300);

    emit('cancel');
}

function handleSubmit() {
    if (!canSubmit.value) {
        return;
    }
    form.post(route('assets.update-usage-category', assetId.value), {
        preserveState: true,
        onSuccess: () => {
            eventBus.$emit(events.updateNotifications);

            eventBus.$emit(events.assetUsageCategoryUpdated, {
                asset: assetId.value,
                usageCategory: form.usageCategory,
            });

            closeModal();
        },
    });
}

const onOpen = ({ assetId: newAssetId }) => {
    assetId.value = newAssetId;

    form.usageCategory = 'active';
    form.tested_and_calibrated = false;
    form.clearErrors();

    shouldRender.value = true;
    nextTick(() => (show.value = true));
};

onMounted(() => {
    eventBus.$on(events.openConfirmAssetUsageCategoryChangeModal, onOpen);
});

onBeforeUnmount(() => {
    eventBus.$off(events.openConfirmAssetUsageCategoryChangeModal, onOpen);
});
</script>
